import { Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { ClientCesionarioDTO } from '../../interface/client-cesionario.interface';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { PageResult } from 'src/app/common/interfaces/paged-result.interface';
import { MatTableDataSource } from '@angular/material/table';
import { FilterPagination } from '../../interface/company-client.interface';


@Component({
  selector: 'app-client-cesionarios-table',
  templateUrl: './client-cesionarios-table.component.html',
  styleUrls: ['./client-cesionarios-table.component.scss']
})
export class ClientCesionariosTableComponent implements OnInit, OnChanges {

  @ViewChild(MatSort, {static: true})sort: MatSort;
  @ViewChild(MatPaginator, {static: true})paginator: MatPaginator;

  public paginationSort: FilterPagination;
  public dataSource: MatTableDataSource<ClientCesionarioDTO>;
  public columns = [
    'CesionarioRut',
    'CesionarioName',
    'TotalAmountTransferInvoices',
    'NumTransferInvoices',
    'MedianTotalAmountTransferInvoices'
  ];

  @Input()
  public cesionariosPaged: PageResult<ClientCesionarioDTO>;

  @Output() changePagination = new EventEmitter<FilterPagination>;
  @Output() changeSortOrder = new EventEmitter<string>;

  constructor(){
    this.dataSource = new MatTableDataSource([]);
  }
  ngOnInit(){ 
  }

  ngOnChanges(changes: SimpleChanges): void {
    const {results, totalRows, currentPage, pageSize, sortColumn, sortDirection} = this.cesionariosPaged;
    this.dataSource.data = results;
    this.paginator.length = totalRows ?? 0;
    this.paginator.pageIndex = currentPage -1 ?? 0;
    this.paginator.pageSize = pageSize;
    if(sortColumn && sortDirection) {
      this.sort.active = sortColumn;
      this.sort.direction = sortDirection === 'asc' ? 'asc' : 'desc';
    }
  }

  changePaginationTable(event: PageEvent) {
    const pagination: FilterPagination = {
      page: event.pageIndex + 1,
      pageSize: event.pageSize
    };
    this.changePagination.emit(pagination);
  }

  changeSortTable(sortState: Sort){
    if(sortState.direction === ''){
      this.changeSortOrder.emit(null);
      return;
    }
    const sortCol = sortState.active;
    const sortConf = `${sortCol}_${sortState.direction}`;
    this.changeSortOrder.emit(sortConf);

  }
}
